class SiteWideMessaging {
    constructor() {
        // add global class identifier
        this.class = {
            trigger: '.js__siteWideMessaging',
            delay: 1000 * 1.5,
            cookieName: 'siteWideMessaging',
            cookieValue: 1,
            closeButtonId: 'closeSiteWideMessaging',
            modalId: 'modalSiteWideMessaging',
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
        } else {
            this.init();
        }
    }

    /**
     * initialize functions
     */
    init() {
        this.siteWideMessaging();
    }

    /**
     * run side wide messaging
     */
    siteWideMessaging() {
        if (document.querySelectorAll(this.class.trigger).length > 0) {
            document.getElementById(this.class.closeButtonId).addEventListener('click', () => {
                this.setCookie();
            });

            const cookie = this.getCookie(this.class.cookieName);
            if (!cookie) {
                setTimeout(() => {
                    this.openModal();
                }, this.class.delay);
            }
        }
    }

    openModal() {
        // trigger bootstrap modal event
        const modal = new bootstrap.Modal(document.getElementById(this.class.modalId), {});
        modal.show();
    }

    setCookie() {
        document.cookie = `${this.class.cookieName}=${this.class.cookieValue}`;
    }

    // eslint-disable-next-line class-methods-use-this
    getCookie(cname) {
        const name = `${cname}=`;
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i += 1) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    }

    // currently not in use
    deleteCookie() {
        document.cookie = `${this.class.cookieName}=;expires=Thu, 01 Jan 1970`;
    }
}

export default new SiteWideMessaging();
